import { Select as AntSelect, SelectProps } from 'antd';
import styled, { css } from 'styled-components';

export const RuleGroupWrapper = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  margin-bottom: 16px;
`;

export const RuleGroupHeader = styled.div<{ active?: boolean }>`
  display: flex;
  align-items: center;
  padding: 0 12px 0 16px;
  gap: 12px;
  height: 40px;
  border-radius: 4px 4px 0 0;

  background: #f7f7f7;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);

  ${({ active }) => {
    if (active) {
      return css`
        background: #f2f6ff;
        border-top: 4px solid #0046ff;
      `;
    }
  }}
`;

export const RuleGroupHeaderLeft = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const Prefix = styled.div<{ type?: 'Group' | 'group' | 'Rule' | 'rule' }>`
  display: flex;
  gap: 8px;
  align-items: center;
  font-size: 12px;
  width: ${(props) => (props.type === 'Group' || props.type === 'group' ? 'fit-content' : '78px')};
  margin-right: ${(props) => (props.type === 'Group' || props.type === 'group' ? '16px' : '0')};
`;

interface ICusSelect extends SelectProps {
  active?: boolean;
}

export const CusSelect = styled(AntSelect)<ICusSelect>`
  &&.emp-ant-select {
    color: rgba(0, 0, 0, 0.85);

    .emp-ant-select-selector {
      width: 100%;
      height: 28px;
      border-radius: 3px;
      border: solid 1px transparent;
      background-color: transparent;

      ${(props) => {
        if (props?.active) {
          return css`
            background-color: #e6edff;
            border: solid 1px rgba(0, 0, 0, 0.15);
            color: #0046ff;
          `;
        }
      }}
      &:hover {
        border: solid 1px rgba(0, 0, 0, 0.15);
      }

      .emp-ant-select-selection-item {
        font-weight: 500;
        letter-spacing: -0.01em;
        line-height: 26px;
      }

      .emp-ant-select-selection-search-input {
        height: 26px;
      }

      .emp-ant-select-selection-placeholder {
        line-height: 26px;
      }
    }

    .emp-ant-select-item-option {
      padding: 6px 8px;
      height: 32px;
      display: flex;
      align-items: center;
      color: rgba(0, 0, 0, 0.65);
      letter-spacing: -0.01em;
      font-weight: 400;
    }

    .emp-ant-select-item-option-selected:not(.emp-ant-select-item-option-disabled) {
      background: #e6edff;
    }

    .emp-ant-select-item-option-content {
      line-height: 20px;
    }

    .emp-ant-select-dropdown {
      width: fit-content !important;
    }
  }
`;

export const AddRuleButtonWrapper = styled.div`
  height: 48px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  padding-left: 34px;
  border-top: 2px solid rgba(0, 0, 0, 0.06);
`;
